var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgApproveFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7412_19378)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4205 9.01468C16.7256 9.31985 16.7256 9.81454 16.4205 10.1196L11.1794 15.3608C10.8742 15.6658 10.3797 15.6658 10.0745 15.3608L7.57953 12.8657C7.27435 12.5607 7.27435 12.066 7.57953 11.761C7.88455 11.4558 8.37924 11.4558 8.68427 11.761L10.6269 13.7036L15.3156 9.01468C15.6208 8.70966 16.1154 8.70966 16.4205 9.01468ZM22 12.1877C22 17.7152 17.5267 22.1877 12 22.1877C6.4725 22.1877 2 17.7145 2 12.1877C2 6.66025 6.47327 2.18774 12 2.18774C17.5275 2.18774 22 6.66101 22 12.1877ZM20.4375 12.1877C20.4375 7.5239 16.6632 3.75024 12 3.75024C7.33615 3.75024 3.5625 7.52451 3.5625 12.1877C3.5625 16.8516 7.33676 20.6252 12 20.6252C16.6638 20.6252 20.4375 16.851 20.4375 12.1877Z",
    fill: "#E94D51"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7412_19378"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2 2.18774)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApproveFilled);
export default __webpack_public_path__ + "static/media/approve-filled.964eb973b249c8afd7d3da901855526f.svg";
export { ForwardRef as ReactComponent };